/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export const defaultLocale = "en-US";
export const fallbackLocale = "en-US";
export const locales = [
	"ar",
	"bg",
	"cs",
	"da",
	"de",
	"en-US",
	"es-ES",
	"es-MX",
	"fi",
	"fil",
	"fr",
	"hi",
	"hu",
	"id",
	"it",
	"ja",
	"ko",
	"ms",
	"nl",
	"no",
	"pl",
	"pt",
	"pt-BR",
	"ro",
	"ru",
	"sv",
	"th",
	"tr",
	"uk",
	"vi",
	"zh-CN",
	"zh-Hant",
];
export const hygraphLocales = [
	"ar",
	"bg",
	"cs",
	"da",
	"de",
	"en",
	"es_ES",
	"es_MX",
	"fi",
	"fil",
	"fr",
	"hi",
	"hu",
	"id",
	"it",
	"ja",
	"ko",
	"ms",
	"nl",
	"no",
	"pl",
	"pt",
	"pt_BR",
	"ro",
	"ru",
	"sv",
	"th",
	"tr",
	"uk",
	"vi",
	"zh_CN",
	"zh_TW",
];

/**
 * Optional mapping of unsupported ISO 639 locale codes to supported ones.
 * This allows redirecting from legacy or unsupported locale codes to the correct locale.
 * @example { "en": "en-US", "zh": "zh-CN" }
 */
export const unsupportedLocaleMapping: Record<string, (typeof locales)[number]> = {
	en: "en-US",
};

export const i18n = {
	fallbackLocale,
	defaultLocale,
	locales,
	hygraphLocales,
	unsupportedLocaleMapping,
};
